export default "__VITE_PUBLIC_ASSET__f53b257b__"